export const settingBase = {
    ":root": {
        "--all-colors": "--active-button-hover, --attention1-1, --attention1-2, --blue-1, --brand-1-0, --brand-1-1, --brand-1-23, --brand-1-25, --brand-1-25-2, --brand-1-4, --brand-1-8, --brand-1-9, --brand-2-1, --brand-2-23, --brand1-0, --brand1-1, --brand1-23, --brand1-25, --brand1-4, --brand1-8, --brand1-9, --brandgradient1-1, --btn-bg, --danger-1, --danger1-1, --danger2-25, --danger3-1, --darger-1, --error1-1, --error1-2, --error4-1, --gold1-9, --gold5-1, --grey-0, --grey-0_2, --grey-0_45, --grey-0_6, --grey-1, --grey-1-b, --grey-1-d, --grey-1m, --grey-1m-b, --grey-2, --grey-2-a, --grey-2-b, --grey-25-b, --grey-2_3, --grey-2_5, --grey-3, --grey-3-b, --grey-4, --grey-4-b, --grey-4_5, --grey-5, --grey-5_5, --grey-6, --grey-7, --histogram-1, --histogram-2, --icon-primary, --line-1, --line-2, --line-3, --line-4, --line-5, --line-color, --miaobi1-1, --miaobi1-23, --miaobi1-25, --miaobi1-4, --miaobi1-5, --miaobi1-8, --miaobi1-9, --pop-bg, --pop-bg-2, --primary-color, --red-1-0, --red-1-1, --red-1-23, --red-1-25, --red-1-4, --red-1-8, --red-1-9, --red1-0, --red1-1, --red1-23, --red1-25, --red1-4, --red1-8, --red1-9, --safe-1, --scrim-m, --scrim-pc, --shadow-down4, --shadow-down6, --shadow-down8, --status-bg, --success-4, --success1-1, --success1-2, --success4, --tag, --warning1-1, --warning1-2, --warning1-25, --warning2-1, --warning2-25, --warning2-30, --warning4, --warning4-1",
        "--themes": "skingreen, skinblue, skinyellow, skinpink, skinbrown, skincyan, skingrey"
    }
};
export const colorBase = {
    ":root,[data-theme-mode=\"light\"]": {
        "--active-button-hover": "#D4DEED",
        "--attention1-1": "rgba(30, 113, 239, 1)",
        "--attention1-2": "rgba(228, 238, 253, 1)",
        "--blue-1": "rgba(30, 113, 239, 0.8)",
        "--brand-1-0": "#0562F0",
        "--brand-1-1": "#1E71EF",
        "--brand-1-23": "rgba(30, 113, 239, 0.08)",
        "--brand-1-25": "rgba(30, 113, 239, 0.2)",
        "--brand-1-25-2": "rgba(30, 113, 239, 0.12)",
        "--brand-1-4": "rgba(30, 113, 239, 0.4)",
        "--brand-1-8": "rgba(30, 113, 239, 0.8)",
        "--brand-1-9": "rgba(30, 113, 239, 0.9)",
        "--brand-2-1": "rgba(247, 132, 130, 1)",
        "--brand-2-23": "rgba(30, 113, 239, 0.08)",
        "--brand1-0": "rgba(5, 98, 240, 1)",
        "--brand1-1": "rgba(30, 113, 239, 1)",
        "--brand1-23": "rgba(30, 113, 239, 0.08)",
        "--brand1-25": "rgba(30, 113, 239, 0.12)",
        "--brand1-4": "rgba(30, 113, 239, 0.4)",
        "--brand1-8": "rgba(30, 113, 239, 0.8)",
        "--brand1-9": "rgba(30, 113, 239, 0.9)",
        "--brandgradient1-1": "linear-gradient(90deg, rgba(92, 158, 240, 1) 0%, rgba(0, 103, 229, 1) 100%)",
        "--btn-bg": "rgba(255, 255, 255, 0.64)",
        "--danger-1": "rgba(247, 132, 130, 0.64)",
        "--danger1-1": "rgba(244, 100, 66, 1)",
        "--danger2-25": "rgba(244, 100, 66, 0.2)",
        "--danger3-1": "rgba(217, 78, 21, 1)",
        "--darger-1": "rgba(247, 132, 130, 0.64)",
        "--error1-1": "rgba(234, 52, 71, 1)",
        "--error1-2": "rgba(253, 235, 237, 1)",
        "--error4-1": "rgba(204, 44, 41, 1)",
        "--gold1-9": "linear-gradient(\n    90deg,\n    rgba(231, 206, 138, 1) 0%,\n    rgba(255, 239, 196, 1) 100%\n  )",
        "--gold5-1": "rgba(89, 56, 25, 1)",
        "--grey-0": "rgba(255, 255, 255, 0.92)",
        "--grey-0_2": "rgba(255, 255, 255, 0.64)",
        "--grey-0_45": "rgba(20, 30, 41, 0.49)",
        "--grey-0_6": "rgba(20, 30, 41, 0.92)",
        "--grey-1": "rgba(255, 255, 255, 1)",
        "--grey-1-b": "rgba(249, 249, 250, 1)",
        "--grey-1-d": "#fff",
        "--grey-1m": "rgba(255, 255, 255, 1)",
        "--grey-1m-b": "rgba(245, 248, 252, 1)",
        "--grey-2": "rgba(20, 30, 41, 0.04)",
        "--grey-2-a": "rgba(255, 255, 255, 0.3)",
        "--grey-2-b": "rgba(245, 245, 247, 1)",
        "--grey-25-b": "rgba(235, 235, 236, 1)",
        "--grey-2_3": "rgba(20, 30, 41, 0.08)",
        "--grey-2_5": "rgba(20, 30, 41, 0.12)",
        "--grey-3": "rgba(20, 30, 41, 0.18)",
        "--grey-3-b": "#C9CDD4",
        "--grey-4": "rgba(20, 30, 41, 0.34)",
        "--grey-4-b": "#FFFFFF",
        "--grey-4_5": "rgba(20, 30, 41, 0.49)",
        "--grey-5": "rgba(20, 30, 41, 0.64)",
        "--grey-5_5": "rgba(20, 30, 41, 0.76)",
        "--grey-6": "rgba(20, 30, 41, 0.92)",
        "--grey-7": "rgba(20, 30, 41, 1)",
        "--histogram-1": "rgba(30, 113, 239, 0.12)",
        "--histogram-2": "rgba(247, 132, 130, 0.14)",
        "--icon-primary": "#1E71EF",
        "--line-1": "rgba(0, 103, 229, 1)",
        "--line-2": "rgba(255, 195, 0, 1)",
        "--line-3": "rgba(255, 148, 61, 1)",
        "--line-4": "rgba(247, 132, 130, 1)",
        "--line-5": "rgba(123, 97, 255, 1)",
        "--line-color": "#ABAFB3",
        "--miaobi1-1": "linear-gradient(251deg, #5BF 1.54%, #A041FF 100%)",
        "--miaobi1-23": "linear-gradient(252deg, rgba(85, 187, 255, 0.08) 3.23%, rgba(160, 65, 255, 0.08) 100%)",
        "--miaobi1-25": "linear-gradient(252deg, rgba(85, 187, 255, 0.20) 1.68%, rgba(160, 65, 255, 0.20) 100%)",
        "--miaobi1-4": "linear-gradient(252deg, rgba(85, 187, 255, 0.40) 2.26%, rgba(160, 65, 255, 0.40) 100%)",
        "--miaobi1-5": "linear-gradient(252deg, rgba(85, 187, 255, 0.60) 2.73%, rgba(160, 65, 255, 0.60) 100%)",
        "--miaobi1-8": "linear-gradient(251deg, rgba(85, 187, 255, 0.80) 1.54%, rgba(160, 65, 255, 0.80) 100%)",
        "--miaobi1-9": "linear-gradient(251deg, rgba(85, 187, 255, 0.90) 1.54%, rgba(160, 65, 255, 0.90) 100%)",
        "--pop-bg": "rgba(255, 255, 255, .5)",
        "--pop-bg-2": "rgba(255, 255, 255, 1)",
        "--primary-color": "#1E71EF",
        "--red-1-0": "#D82631",
        "--red-1-1": "#EA3447",
        "--red-1-23": "rgba(234, 52, 71, 0.08)",
        "--red-1-25": "rgba(234, 52, 71, 0.12)",
        "--red-1-4": "rgba(234, 52, 71, 0.4)",
        "--red-1-8": "rgba(234, 52, 71, 0.8)",
        "--red-1-9": "rgba(234, 52, 71, 0.9)",
        "--red1-0": "rgba(216, 38, 49, 1)",
        "--red1-1": "rgba(234, 52, 71, 1)",
        "--red1-23": "rgba(234, 52, 71, 0.08)",
        "--red1-25": "rgba(234, 52, 71, 0.12)",
        "--red1-4": "rgba(234, 52, 71, 0.4)",
        "--red1-8": "rgba(234, 52, 71, 0.8)",
        "--red1-9": "rgba(234, 52, 71, 0.9)",
        "--safe-1": "rgba(71, 204, 107, 0.64)",
        "--scrim-m": "rgba(0, 0, 0, 0.64)",
        "--scrim-pc": "rgba(0, 0, 0, 0.36)",
        "--shadow-down4": "rgba(0, 0, 0, 0.04)",
        "--shadow-down6": "rgba(0, 0, 0, 0.14)",
        "--shadow-down8": "rgba(0, 0, 0, 0.24)",
        "--status-bg": "rgba(228, 233, 239, 1)",
        "--success-4": "rgba(50, 166, 85, 1)",
        "--success1-1": "rgba(48, 193, 87, 1)",
        "--success1-2": "rgba(227, 247, 233, 1)",
        "--success4": "#32A655",
        "--tag": "rgba(242, 158, 61, 0.9)",
        "--warning1-1": "rgba(244, 187, 0, 1)",
        "--warning1-2": "rgba(255, 244, 206, 1)",
        "--warning1-25": "rgba(255, 195, 0, 0.2)",
        "--warning2-1": "rgba(255, 148, 61, 1)",
        "--warning2-25": "rgba(255, 148, 61, 0.2)",
        "--warning2-30": "rgba(255, 234, 216, 1)",
        "--warning4": "rgba(217, 159, 0, 1)",
        "--warning4-1": "rgba(229, 111, 0, 1)",
        "color-scheme": "light"
    },
    "[data-theme-mode=\"dark\"],[data-theme-mode=\"dark\"][data-theme-namespace=\"default\"]": {
        "--active-button-hover": "#1A4167",
        "--attention1-1": "rgba(38, 117, 214, 1)",
        "--attention1-2": "rgba(6, 49, 90, 1)",
        "--blue-1": "rgba(30, 113, 239, 0.8)",
        "--brand-1-0": "#5B93FF",
        "--brand-1-1": "#4E8AFE",
        "--brand-1-23": "rgba(30, 113, 239, 0.12)",
        "--brand-1-25": "rgba(38, 117, 214, 0.28)",
        "--brand-1-25-2": "rgba(38, 117, 214, 0.5)",
        "--brand-1-4": "rgba(38, 117, 214, 0.4)",
        "--brand-1-8": "rgba(38, 117, 214, 0.8)",
        "--brand-1-9": "rgba(78, 138, 254, 0.9)",
        "--brand-2-1": "rgba(247, 132, 130, 1)",
        "--brand-2-23": "rgba(38, 117, 214, 0.12)",
        "--brand1-0": "rgba(91, 147, 255, 1)",
        "--brand1-1": "rgba(78, 138, 254, 1)",
        "--brand1-23": "rgba(78, 138, 254, 0.12)",
        "--brand1-25": "rgba(30, 113, 239, 0.28)",
        "--brand1-4": "rgba(78, 138, 254, 0.4)",
        "--brand1-8": "rgba(78, 138, 254, 0.8)",
        "--brand1-9": "rgba(78, 138, 254, 0.9)",
        "--brandgradient1-1": "linear-gradient(90deg, rgba(92, 158, 240, 1) 0%, rgba(0, 103, 229, 1) 100%)",
        "--btn-bg": "rgba(255, 255, 255, 0.06)",
        "--darger-1": "rgba(247, 132, 130, 0.64)",
        "--error1-1": "rgba(199, 53, 81, 1)",
        "--error1-2": "rgba(86, 43, 42, 1)",
        "--error4-1": "rgba(255, 179, 173, 1)",
        "--gold1-9": "linear-gradient(\n    90deg,\n    rgba(240, 215, 144, 1) 0%,\n    rgba(255, 240, 196, 1) 100%\n  )",
        "--gold5-1": "rgba(163, 121, 62, 1)",
        "--grey-0": "rgba(255, 255, 255, 0.92)",
        "--grey-0_2": "rgba(255, 255, 255, 0.64)",
        "--grey-0_45": "rgba(20, 30, 41, 0.49)",
        "--grey-0_6": "rgba(20, 30, 41, 0.92)",
        "--grey-1": "rgba(54, 54, 54, 1)",
        "--grey-1-b": "rgba(48, 48, 48, 1)",
        "--grey-1-d": "#4f4f4f",
        "--grey-1m": "rgba(28, 28, 28, 1)",
        "--grey-1m-b": "rgba(15, 15, 15, 1)",
        "--grey-2": "rgba(255, 255, 255, 0.04)",
        "--grey-2-a": "rgba(255, 255, 255, 0.08)",
        "--grey-2-b": "rgba(41, 41, 41, 1)",
        "--grey-25-b": "rgba(30, 30, 30, 1)",
        "--grey-2_3": "rgba(255, 255, 255, 0.12)",
        "--grey-2_5": "rgba(255, 255, 255, 0.16)",
        "--grey-3": "rgba(255, 255, 255, 0.2)",
        "--grey-3-b": "#474747",
        "--grey-4": "rgba(255, 255, 255, 0.34)",
        "--grey-4-b": "#666666",
        "--grey-4_5": "rgba(255, 255, 255, 0.49)",
        "--grey-5": "rgba(255, 255, 255, 0.64)",
        "--grey-5_5": "rgba(255, 255, 255, 0.76)",
        "--grey-6": "rgba(255, 255, 255, 0.92)",
        "--grey-7": "rgba(255, 255, 255, 1)",
        "--histogram-1": "rgba(30, 113, 239, 0.12)",
        "--histogram-2": "rgba(247, 132, 130, 0.14)",
        "--icon-primary": "#4E8AFE",
        "--line-1": "#0067E6",
        "--line-2": "#FFC300",
        "--line-3": "#FF943D",
        "--line-4": "#F78482",
        "--line-5": "#7B61FF",
        "--line-color": "#767676",
        "--miaobi1-1": "linear-gradient(251deg, #5BF 1.54%, #A041FF 100%)",
        "--miaobi1-23": "linear-gradient(252deg, rgba(85, 187, 255, 0.08) 3.23%, rgba(160, 65, 255, 0.08) 100%)",
        "--miaobi1-25": "linear-gradient(252deg, rgba(85, 187, 255, 0.20) 1.68%, rgba(160, 65, 255, 0.20) 100%)",
        "--miaobi1-4": "linear-gradient(252deg, rgba(85, 187, 255, 0.40) 2.26%, rgba(160, 65, 255, 0.40) 100%)",
        "--miaobi1-5": "linear-gradient(252deg, rgba(85, 187, 255, 0.55) 2.73%, rgba(160, 65, 255, 0.55) 100%)",
        "--miaobi1-8": "linear-gradient(251deg, rgba(85, 187, 255, 0.70) 1.54%, rgba(160, 65, 255, 0.70) 100%)",
        "--miaobi1-9": "linear-gradient(251deg, rgba(85, 187, 255, 0.85) 1.54%, rgba(160, 65, 255, 0.85) 100%)",
        "--pop-bg": "#292929",
        "--pop-bg-2": "#292929",
        "--primary-color": "#4E8AFE",
        "--red-1-0": "#F45868",
        "--red-1-1": "#C73551",
        "--red-1-23": "rgba(226, 66, 83, 0.08)",
        "--red-1-25": "rgba(226, 66, 83, 0.12)",
        "--red-1-4": "rgba(226, 66, 83, 0.4)",
        "--red-1-8": "rgba(226, 66, 83, 0.8)",
        "--red-1-9": "rgba(226, 66, 83, 0.9)",
        "--red1-0": "rgba(244, 88, 104, 1)",
        "--red1-1": "rgba(226, 66, 83, 1)",
        "--red1-23": "rgba(226, 66, 83, 0.16)",
        "--red1-25": "rgba(226, 66, 83, 0.24)",
        "--red1-4": "rgba(226, 66, 83, 0.4)",
        "--red1-8": "rgba(226, 66, 83, 0.8)",
        "--red1-9": "rgba(226, 66, 83, 0.9)",
        "--safe-1": "rgba(71, 204, 107, 0.64)",
        "--scrim-m": "rgba(0, 0, 0, 0.64)",
        "--scrim-pc": "rgba(0, 0, 0, 0.36)",
        "--shadow-down4": "rgba(0, 0, 0, 0.14)",
        "--shadow-down6": "rgba(0, 0, 0, 0.24)",
        "--shadow-down8": "rgba(0, 0, 0, 0.34)",
        "--status-bg": "rgba(30, 30, 30, 1)",
        "--success1-1": "rgba(108, 203, 95, 1)",
        "--success1-2": "rgba(68, 79, 46, 1)",
        "--success4": "rgba(50, 166, 85, 1)",
        "--tag": "rgba(242, 158, 61, 0.9)",
        "--warning1-1": "rgba(255, 195, 0, 1)",
        "--warning1-2": "rgba(85, 75, 41, 1)",
        "--warning1-25": "rgba(255, 195, 0, 0.2)",
        "--warning2-1": "rgba(255, 148, 61, 1)",
        "--warning2-25": "rgba(255, 148, 61, 0.2)",
        "--warning2-30": "rgba(83, 59, 37, 1)",
        "--warning4": "rgba(217, 159, 0, 1)",
        "--warning4-1": "rgba(255, 182, 137, 1)",
        "color-scheme": "dark"
    },
    "[data-theme-namespace=\"skingreen\"]": {
        "--grey-1": "rgba(216, 233, 216, 1)",
        "--grey-1-b": "rgba(207, 229, 207, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.3)",
        "--grey-2-b": "rgba(199, 224, 199, 1)",
        "--grey-25-b": "rgba(189, 215, 189, 1)",
        "--status-bg": "rgba(189, 215, 189, 1)"
    },
    "[data-theme-namespace=\"skinyellow\"]": {
        "--grey-1": "rgba(237, 228, 209, 1)",
        "--grey-1-b": "rgba(233, 222, 200, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.3)",
        "--grey-2-b": "rgba(229, 216, 190, 1)",
        "--grey-25-b": "rgba(220, 207, 183, 1)",
        "--status-bg": "rgba(220, 207, 183, 1)"
    },
    "[data-theme-namespace=\"skinpink\"]": {
        "--grey-1": "rgba(244, 231, 234, 1)",
        "--grey-1-b": "rgba(242, 226, 229, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.3)",
        "--grey-2-b": "rgba(240, 221, 225, 1)",
        "--grey-25-b": "rgba(231, 212, 216, 1)",
        "--status-bg": "rgba(231, 212, 216, 1)"
    },
    "[data-theme-namespace=\"skinblue\"]": {
        "--grey-1": "rgba(224, 232, 241, 1)",
        "--grey-1-b": "rgba(218, 227, 238, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.3)",
        "--grey-2-b": "rgba(211, 222, 235, 1)",
        "--grey-25-b": "rgba(203, 213, 226, 1)",
        "--status-bg": "rgba(203, 213, 226, 1)"
    },
    "[data-theme-mode=\"dark\"][data-theme-namespace=\"skingrey\"]": {
        "--grey-1": "rgba(96, 102, 110, 1)",
        "--grey-1-b": "rgba(87, 94, 102, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.08)",
        "--grey-2-b": "rgba(78, 85, 94, 1)",
        "--grey-25-b": "rgba(62, 68, 75, 1)",
        "--status-bg": "rgba(62, 68, 75, 1)"
    },
    "[data-theme-mode=\"dark\"][data-theme-namespace=\"skincyan\"]": {
        "--grey-1": "rgba(53, 67, 89, 1)",
        "--grey-1-b": "rgba(42, 56, 80, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.08)",
        "--grey-2-b": "rgba(31, 46, 71, 1)",
        "--grey-25-b": "rgba(25, 37, 57, 1)",
        "--status-bg": "rgba(25, 37, 57, 1)"
    },
    "[data-theme-mode=\"dark\"][data-theme-namespace=\"skinbrown\"]": {
        "--grey-1": "rgba(78, 64, 37, 1)",
        "--grey-1-b": "rgba(68, 54, 25, 1)",
        "--grey-2-a": "rgba(255, 255, 255, 0.08)",
        "--grey-2-b": "rgba(58, 43, 13, 1)",
        "--grey-25-b": "rgba(46, 34, 10, 1)",
        "--status-bg": "rgba(46, 34, 10, 1)"
    }
};
export const colorTheme = {
    "active-button-hover": "var(--active-button-hover,#D4DEED)",
    "attention1-1": "var(--attention1-1,rgba(30,113,239,1))",
    "attention1-2": "var(--attention1-2,rgba(228,238,253,1))",
    "blue-1": "var(--blue-1,rgba(30,113,239,0.8))",
    "brand-1-0": "var(--brand-1-0,#0562F0)",
    "brand-1-1": "var(--brand-1-1,#1E71EF)",
    "brand-1-23": "var(--brand-1-23,rgba(30,113,239,0.08))",
    "brand-1-25": "var(--brand-1-25,rgba(30,113,239,0.2))",
    "brand-1-25-2": "var(--brand-1-25-2,rgba(30,113,239,0.12))",
    "brand-1-4": "var(--brand-1-4,rgba(30,113,239,0.4))",
    "brand-1-8": "var(--brand-1-8,rgba(30,113,239,0.8))",
    "brand-1-9": "var(--brand-1-9,rgba(30,113,239,0.9))",
    "brand-2-1": "var(--brand-2-1,rgba(247,132,130,1))",
    "brand-2-23": "var(--brand-2-23,rgba(30,113,239,0.08))",
    "brand1-0": "var(--brand1-0,rgba(5,98,240,1))",
    "brand1-1": "var(--brand1-1,rgba(30,113,239,1))",
    "brand1-23": "var(--brand1-23,rgba(30,113,239,0.08))",
    "brand1-25": "var(--brand1-25,rgba(30,113,239,0.12))",
    "brand1-4": "var(--brand1-4,rgba(30,113,239,0.4))",
    "brand1-8": "var(--brand1-8,rgba(30,113,239,0.8))",
    "brand1-9": "var(--brand1-9,rgba(30,113,239,0.9))",
    "brandgradient1-1": "var(--brandgradient1-1,linear-gradient(90deg,rgba(92,158,240,1) 0%,rgba(0,103,229,1) 100%))",
    "btn-bg": "var(--btn-bg,rgba(255,255,255,0.64))",
    "danger-1": "var(--danger-1,rgba(247,132,130,0.64))",
    "danger1-1": "var(--danger1-1,rgba(244,100,66,1))",
    "danger2-25": "var(--danger2-25,rgba(244,100,66,0.2))",
    "danger3-1": "var(--danger3-1,rgba(217,78,21,1))",
    "darger-1": "var(--darger-1,rgba(247,132,130,0.64))",
    "error1-1": "var(--error1-1,rgba(234,52,71,1))",
    "error1-2": "var(--error1-2,rgba(253,235,237,1))",
    "error4-1": "var(--error4-1,rgba(204,44,41,1))",
    "gold1-9": "var(--gold1-9,linear-gradient(\n    90deg,rgba(231,206,138,1) 0%,rgba(255,239,196,1) 100%\n  ))",
    "gold5-1": "var(--gold5-1,rgba(89,56,25,1))",
    "grey-0": "var(--grey-0,rgba(255,255,255,0.92))",
    "grey-0_2": "var(--grey-0_2,rgba(255,255,255,0.64))",
    "grey-0_45": "var(--grey-0_45,rgba(20,30,41,0.49))",
    "grey-0_6": "var(--grey-0_6,rgba(20,30,41,0.92))",
    "grey-1": "var(--grey-1,rgba(255,255,255,1))",
    "grey-1-b": "var(--grey-1-b,rgba(249,249,250,1))",
    "grey-1-d": "var(--grey-1-d,#fff)",
    "grey-1m": "var(--grey-1m,rgba(255,255,255,1))",
    "grey-1m-b": "var(--grey-1m-b,rgba(245,248,252,1))",
    "grey-2": "var(--grey-2,rgba(20,30,41,0.04))",
    "grey-2-a": "var(--grey-2-a,rgba(255,255,255,0.3))",
    "grey-2-b": "var(--grey-2-b,rgba(245,245,247,1))",
    "grey-25-b": "var(--grey-25-b,rgba(235,235,236,1))",
    "grey-2_3": "var(--grey-2_3,rgba(20,30,41,0.08))",
    "grey-2_5": "var(--grey-2_5,rgba(20,30,41,0.12))",
    "grey-3": "var(--grey-3,rgba(20,30,41,0.18))",
    "grey-3-b": "var(--grey-3-b,#C9CDD4)",
    "grey-4": "var(--grey-4,rgba(20,30,41,0.34))",
    "grey-4-b": "var(--grey-4-b,#FFFFFF)",
    "grey-4_5": "var(--grey-4_5,rgba(20,30,41,0.49))",
    "grey-5": "var(--grey-5,rgba(20,30,41,0.64))",
    "grey-5_5": "var(--grey-5_5,rgba(20,30,41,0.76))",
    "grey-6": "var(--grey-6,rgba(20,30,41,0.92))",
    "grey-7": "var(--grey-7,rgba(20,30,41,1))",
    "histogram-1": "var(--histogram-1,rgba(30,113,239,0.12))",
    "histogram-2": "var(--histogram-2,rgba(247,132,130,0.14))",
    "icon-primary": "var(--icon-primary,#1E71EF)",
    "line-1": "var(--line-1,rgba(0,103,229,1))",
    "line-2": "var(--line-2,rgba(255,195,0,1))",
    "line-3": "var(--line-3,rgba(255,148,61,1))",
    "line-4": "var(--line-4,rgba(247,132,130,1))",
    "line-5": "var(--line-5,rgba(123,97,255,1))",
    "line-color": "var(--line-color,#ABAFB3)",
    "miaobi1-1": "var(--miaobi1-1,linear-gradient(251deg,#5BF 1.54%,#A041FF 100%))",
    "miaobi1-23": "var(--miaobi1-23,linear-gradient(252deg,rgba(85,187,255,0.08) 3.23%,rgba(160,65,255,0.08) 100%))",
    "miaobi1-25": "var(--miaobi1-25,linear-gradient(252deg,rgba(85,187,255,0.20) 1.68%,rgba(160,65,255,0.20) 100%))",
    "miaobi1-4": "var(--miaobi1-4,linear-gradient(252deg,rgba(85,187,255,0.40) 2.26%,rgba(160,65,255,0.40) 100%))",
    "miaobi1-5": "var(--miaobi1-5,linear-gradient(252deg,rgba(85,187,255,0.60) 2.73%,rgba(160,65,255,0.60) 100%))",
    "miaobi1-8": "var(--miaobi1-8,linear-gradient(251deg,rgba(85,187,255,0.80) 1.54%,rgba(160,65,255,0.80) 100%))",
    "miaobi1-9": "var(--miaobi1-9,linear-gradient(251deg,rgba(85,187,255,0.90) 1.54%,rgba(160,65,255,0.90) 100%))",
    "pop-bg": "var(--pop-bg,rgba(255,255,255,.5))",
    "pop-bg-2": "var(--pop-bg-2,rgba(255,255,255,1))",
    "primary-color": "var(--primary-color,#1E71EF)",
    "red-1-0": "var(--red-1-0,#D82631)",
    "red-1-1": "var(--red-1-1,#EA3447)",
    "red-1-23": "var(--red-1-23,rgba(234,52,71,0.08))",
    "red-1-25": "var(--red-1-25,rgba(234,52,71,0.12))",
    "red-1-4": "var(--red-1-4,rgba(234,52,71,0.4))",
    "red-1-8": "var(--red-1-8,rgba(234,52,71,0.8))",
    "red-1-9": "var(--red-1-9,rgba(234,52,71,0.9))",
    "red1-0": "var(--red1-0,rgba(216,38,49,1))",
    "red1-1": "var(--red1-1,rgba(234,52,71,1))",
    "red1-23": "var(--red1-23,rgba(234,52,71,0.08))",
    "red1-25": "var(--red1-25,rgba(234,52,71,0.12))",
    "red1-4": "var(--red1-4,rgba(234,52,71,0.4))",
    "red1-8": "var(--red1-8,rgba(234,52,71,0.8))",
    "red1-9": "var(--red1-9,rgba(234,52,71,0.9))",
    "safe-1": "var(--safe-1,rgba(71,204,107,0.64))",
    "scrim-m": "var(--scrim-m,rgba(0,0,0,0.64))",
    "scrim-pc": "var(--scrim-pc,rgba(0,0,0,0.36))",
    "shadow-down4": "var(--shadow-down4,rgba(0,0,0,0.04))",
    "shadow-down6": "var(--shadow-down6,rgba(0,0,0,0.14))",
    "shadow-down8": "var(--shadow-down8,rgba(0,0,0,0.24))",
    "status-bg": "var(--status-bg,rgba(228,233,239,1))",
    "success-4": "var(--success-4,rgba(50,166,85,1))",
    "success1-1": "var(--success1-1,rgba(48,193,87,1))",
    "success1-2": "var(--success1-2,rgba(227,247,233,1))",
    "success4": "var(--success4,#32A655)",
    "tag": "var(--tag,rgba(242,158,61,0.9))",
    "transparent": "transparent",
    "warning1-1": "var(--warning1-1,rgba(244,187,0,1))",
    "warning1-2": "var(--warning1-2,rgba(255,244,206,1))",
    "warning1-25": "var(--warning1-25,rgba(255,195,0,0.2))",
    "warning2-1": "var(--warning2-1,rgba(255,148,61,1))",
    "warning2-25": "var(--warning2-25,rgba(255,148,61,0.2))",
    "warning2-30": "var(--warning2-30,rgba(255,234,216,1))",
    "warning4": "var(--warning4,rgba(217,159,0,1))",
    "warning4-1": "var(--warning4-1,rgba(229,111,0,1))"
};
export const legacyBase = undefined;
export const nameMap = {
    "grey-0": "白无反色（蓝色高亮底上主文案）",
    "grey-1": "",
    "grey-1-b": "默认背景色",
    "grey-2": "",
    "grey-2_3": "灰（普通分割线）移动端次按钮底色",
    "grey-2_5": "灰（按钮描边、pressed按钮底色）",
    "grey-2-a": "次要按钮底色",
    "grey-2-b": "",
    "grey-25-b": "菜单标题栏",
    "grey-3": "pressed背景色",
    "grey-4": "灰（占位符、未选中图标）",
    "grey-4_5": "未选中文案",
    "grey-5": "选中图标",
    "grey-5_5": "按钮文字、章节列表文字",
    "grey-6": "主文案",
    "status-bg": "系统工具栏",
    "attention1-1": "系统（搜索结果内容）",
    "attention1-2": "系统（搜索结果高亮底色）",
    "success1-1": "成功",
    "success1-2": "成功底色",
    "success4": "系统（成功文字）",
    "warning1-1": "系统（警告）",
    "warning1-2": "系统（警告底色）",
    "warning1-25": "警告文字高亮",
    "warning2-1": "系统（错误高亮、运营活动文字）",
    "warning2-25": "错误文字背景高亮（透明）",
    "warning4-1": "系统（敏感文字）",
    "error1-1": "错误",
    "error1-2": "系统（错误底色）",
    "error4-1": "错误文字",
    "danger1-1": "系统色（危险）",
    "danger2-25": "系统（危险背景高亮）",
    "danger3-1": "系统（危险文字）",
    "gold5-1": "起点大学",
    "gold1-9": "起点大学底色",
    "tag": "",
    "blue-1": "图表（普通）",
    "safe-1": "图表（未监测到泄漏数据）",
    "line-1": "图表（折线图01）",
    "line-2": "图表（折线图02）",
    "line-3": "图表（折线图03）",
    "line-4": "图表（折线图04）",
    "line-5": "图表（折线图05）",
    "histogram-1": "图表（直方图01）",
    "histogram-2": "图表（直方图02）",
    "grey-0_2": "白无反色（蓝色高亮底上辅助文案）",
    "grey-0_6": "",
    "grey-0_45": "不做反色的深色按钮背景（浅黑）",
    "brand1-0": "主按钮底色-默认、激活文字",
    "brand1-1": "蓝主色（主按钮底色-默认、激活文字）",
    "brand1-9": "主按钮底色-hover",
    "brand1-8": "图表填充",
    "brand1-4": "禁用主按钮底色",
    "brand1-25": "选中态大面积底色",
    "brand1-23": "选中态小面积底色（标签）",
    "brandgradient1-1": "蓝渐变（悬浮按钮默认底色）",
    "miaobi1-1": "妙笔专用",
    "miaobi1-9": "",
    "miaobi1-8": "",
    "miaobi1-4": "",
    "miaobi1-25": "",
    "miaobi1-23": "",
    "red1-0": "主按钮底色-pressed",
    "red1-1": "主按钮底色-默认、激活文字",
    "red1-9": "红（主按钮hover底色）",
    "red1-8": "红（图表填充？）",
    "red1-4": "禁用主按钮",
    "red1-25": "大面积底色",
    "red1-23": "红（大面积底色、标签）",
    "grey-1m": "",
    "grey-1m-b": "",
    "scrim-m": "深色遮罩",
    "scrim-pc": "",
    "success-4": "系统（成功文字色）",
    "warning4": "警告文字高亮",
    "warning2-30": "运营卡片背景（无透明）",
    "danger-1": "图表（检测泄漏数据）"
};
